// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/swiper/swiper.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/swiper/modules/navigation.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/swiper/modules/pagination.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/css/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles.css */
/* ! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1rem;
  padding-left: 1rem;
}
@media (min-width: 500px) {
  .container {
    max-width: 500px;
  }
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1440px) {
  .container {
    max-width: 1440px;
  }
}
@media (min-width: 1921px) {
  .container {
    max-width: 1921px;
  }
}
#innovation-process-root :is(.fixed) {
  position: fixed;
}
#innovation-process-root :is(.absolute) {
  position: absolute;
}
#innovation-process-root :is(.relative) {
  position: relative;
}
#innovation-process-root :is(.inset-0) {
  inset: 0px;
}
#innovation-process-root :is(.bottom-\\[90\\%\\]) {
  bottom: 90%;
}
#innovation-process-root :is(.left-1\\/2) {
  left: 50%;
}
#innovation-process-root :is(.top-1\\/2) {
  top: 50%;
}
#innovation-process-root :is(.top-full) {
  top: 100%;
}
#innovation-process-root :is(.z-\\[9999\\]) {
  z-index: 9999;
}
#innovation-process-root :is(.mx-auto) {
  margin-left: auto;
  margin-right: auto;
}
#innovation-process-root :is(.-mt-\\[320px\\]) {
  margin-top: -320px;
}
#innovation-process-root :is(.-mt-\\[400px\\]) {
  margin-top: -400px;
}
#innovation-process-root :is(.mt-2) {
  margin-top: 0.5rem;
}
#innovation-process-root :is(.mt-64) {
  margin-top: 16rem;
}
#innovation-process-root :is(.block) {
  display: block;
}
#innovation-process-root :is(.inline) {
  display: inline;
}
#innovation-process-root :is(.flex) {
  display: flex;
}
#innovation-process-root :is(.inline-flex) {
  display: inline-flex;
}
#innovation-process-root :is(.table) {
  display: table;
}
#innovation-process-root :is(.hidden) {
  display: none;
}
#innovation-process-root :is(.h-0) {
  height: 0px;
}
#innovation-process-root :is(.h-10) {
  height: 2.5rem;
}
#innovation-process-root :is(.h-9) {
  height: 2.25rem;
}
#innovation-process-root :is(.h-\\[90\\%\\]) {
  height: 90%;
}
#innovation-process-root :is(.h-full) {
  height: 100%;
}
#innovation-process-root :is(.w-0) {
  width: 0px;
}
#innovation-process-root :is(.w-\\[120px\\]) {
  width: 120px;
}
#innovation-process-root :is(.w-\\[150\\%\\]) {
  width: 150%;
}
#innovation-process-root :is(.w-\\[168px\\]) {
  width: 168px;
}
#innovation-process-root :is(.w-\\[327px\\]) {
  width: 327px;
}
#innovation-process-root :is(.w-fit) {
  width: -moz-fit-content;
  width: fit-content;
}
#innovation-process-root :is(.w-full) {
  width: 100%;
}
#innovation-process-root :is(.max-w-\\[1248px\\]) {
  max-width: 1248px;
}
#innovation-process-root :is(.max-w-\\[350px\\]) {
  max-width: 350px;
}
#innovation-process-root :is(.flex-1) {
  flex: 1 1;
}
#innovation-process-root :is(.-translate-x-1\\/2) {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#innovation-process-root :is(.-translate-y-1\\/2) {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#innovation-process-root :is(.transform) {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#innovation-process-root :is(.resize) {
  resize: both;
}
#innovation-process-root :is(.flex-row) {
  flex-direction: row;
}
#innovation-process-root :is(.flex-col) {
  flex-direction: column;
}
#innovation-process-root :is(.items-center) {
  align-items: center;
}
#innovation-process-root :is(.items-stretch) {
  align-items: stretch;
}
#innovation-process-root :is(.justify-between) {
  justify-content: space-between;
}
#innovation-process-root :is(.gap-2) {
  gap: 0.5rem;
}
#innovation-process-root :is(.gap-4) {
  gap: 1rem;
}
#innovation-process-root :is(.overflow-auto) {
  overflow: auto;
}
#innovation-process-root :is(.overflow-hidden) {
  overflow: hidden;
}
#innovation-process-root :is(.overflow-y-auto) {
  overflow-y: auto;
}
#innovation-process-root :is(.overflow-x-hidden) {
  overflow-x: hidden;
}
#innovation-process-root :is(.break-words) {
  overflow-wrap: break-word;
}
#innovation-process-root :is(.rounded) {
  border-radius: 0.25rem;
}
#innovation-process-root :is(.rounded-2xl) {
  border-radius: 1rem;
}
#innovation-process-root :is(.rounded-\\[40px\\]) {
  border-radius: 40px;
}
#innovation-process-root :is(.border) {
  border-width: 1px;
}
#innovation-process-root :is(.border-2) {
  border-width: 2px;
}
#innovation-process-root :is(.border-b) {
  border-bottom-width: 1px;
}
#innovation-process-root :is(.border-l-\\[6px\\]) {
  border-left-width: 6px;
}
#innovation-process-root :is(.border-r-\\[6px\\]) {
  border-right-width: 6px;
}
#innovation-process-root :is(.border-t-\\[6px\\]) {
  border-top-width: 6px;
}
#innovation-process-root :is(.border-solid) {
  border-style: solid;
}
#innovation-process-root :is(.border-\\[\\#e7eaee\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(231 234 238 / var(--tw-border-opacity));
}
#innovation-process-root :is(.border-black) {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
#innovation-process-root :is(.border-white) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
#innovation-process-root :is(.border-l-transparent) {
  border-left-color: transparent;
}
#innovation-process-root :is(.border-r-transparent) {
  border-right-color: transparent;
}
#innovation-process-root :is(.border-t-\\[\\#4A4A4A\\]) {
  --tw-border-opacity: 1;
  border-top-color: rgb(74 74 74 / var(--tw-border-opacity));
}
#innovation-process-root :is(.bg-\\[\\#4A4A4A\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(74 74 74 / var(--tw-bg-opacity));
}
#innovation-process-root :is(.bg-black) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
#innovation-process-root :is(.bg-black\\/50) {
  background-color: rgb(0 0 0 / 0.5);
}
#innovation-process-root :is(.bg-transparent) {
  background-color: transparent;
}
#innovation-process-root :is(.bg-white) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
#innovation-process-root :is(.p-4) {
  padding: 1rem;
}
#innovation-process-root :is(.px-2) {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
#innovation-process-root :is(.px-24) {
  padding-left: 6rem;
  padding-right: 6rem;
}
#innovation-process-root :is(.px-4) {
  padding-left: 1rem;
  padding-right: 1rem;
}
#innovation-process-root :is(.px-5) {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
#innovation-process-root :is(.px-\\[25\\%\\]) {
  padding-left: 25%;
  padding-right: 25%;
}
#innovation-process-root :is(.py-2) {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
#innovation-process-root :is(.py-2\\.5) {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
#innovation-process-root :is(.py-3) {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
#innovation-process-root :is(.py-4) {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
#innovation-process-root :is(.py-5) {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
#innovation-process-root :is(.pt-16) {
  padding-top: 4rem;
}
#innovation-process-root :is(.pt-\\[114px\\]) {
  padding-top: 114px;
}
#innovation-process-root :is(.text-left) {
  text-align: left;
}
#innovation-process-root :is(.text-center) {
  text-align: center;
}
#innovation-process-root :is(.text-7xl) {
  font-size: 4.5rem;
  line-height: 1;
}
#innovation-process-root :is(.text-\\[10px\\]) {
  font-size: 10px;
}
#innovation-process-root :is(.text-\\[14px\\]) {
  font-size: 14px;
}
#innovation-process-root :is(.text-\\[18px\\]) {
  font-size: 18px;
}
#innovation-process-root :is(.text-\\[20px\\]) {
  font-size: 20px;
}
#innovation-process-root :is(.text-\\[24px\\]) {
  font-size: 24px;
}
#innovation-process-root :is(.text-\\[32px\\]) {
  font-size: 32px;
}
#innovation-process-root :is(.text-\\[36px\\]) {
  font-size: 36px;
}
#innovation-process-root :is(.text-\\[48px\\]) {
  font-size: 48px;
}
#innovation-process-root :is(.text-\\[56px\\]) {
  font-size: 56px;
}
#innovation-process-root :is(.text-\\[80px\\]) {
  font-size: 80px;
}
#innovation-process-root :is(.text-base) {
  font-size: 1rem;
  line-height: 1.5rem;
}
#innovation-process-root :is(.text-lg) {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
#innovation-process-root :is(.text-sm) {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
#innovation-process-root :is(.text-xl) {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
#innovation-process-root :is(.text-xs) {
  font-size: 0.75rem;
  line-height: 1rem;
}
#innovation-process-root :is(.font-bold) {
  font-weight: 700;
}
#innovation-process-root :is(.font-light) {
  font-weight: 300;
}
#innovation-process-root :is(.font-medium) {
  font-weight: 500;
}
#innovation-process-root :is(.font-semibold) {
  font-weight: 600;
}
#innovation-process-root :is(.capitalize) {
  text-transform: capitalize;
}
#innovation-process-root :is(.italic) {
  font-style: italic;
}
#innovation-process-root :is(.leading-\\[20px\\]) {
  line-height: 20px;
}
#innovation-process-root :is(.leading-\\[24px\\]) {
  line-height: 24px;
}
#innovation-process-root :is(.leading-\\[28px\\]) {
  line-height: 28px;
}
#innovation-process-root :is(.leading-\\[32px\\]) {
  line-height: 32px;
}
#innovation-process-root :is(.leading-\\[44px\\]) {
  line-height: 44px;
}
#innovation-process-root :is(.leading-\\[48px\\]) {
  line-height: 48px;
}
#innovation-process-root :is(.leading-\\[56px\\]) {
  line-height: 56px;
}
#innovation-process-root :is(.leading-\\[80px\\]) {
  line-height: 80px;
}
#innovation-process-root :is(.text-black) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
#innovation-process-root :is(.text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
#innovation-process-root :is(.shadow-lg) {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#innovation-process-root :is(.filter) {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
#innovation-process-root :is(.transition) {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

#innovation-process-root :is(.hover\\:bg-\\[\\#6E6E6E\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(110 110 110 / var(--tw-bg-opacity));
}

#innovation-process-root :is(.hover\\:bg-\\[\\#D4D4D4\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}

#innovation-process-root :is(.disabled\\:cursor-not-allowed:disabled) {
  cursor: not-allowed;
}

#innovation-process-root :is(.disabled\\:border-\\[\\#9B9B9B\\]:disabled) {
  --tw-border-opacity: 1;
  border-color: rgb(155 155 155 / var(--tw-border-opacity));
}

#innovation-process-root :is(.disabled\\:border-\\[\\#D4D4D4\\]:disabled) {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / var(--tw-border-opacity));
}

#innovation-process-root :is(.disabled\\:bg-\\[\\#D4D4D4\\]:disabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}

#innovation-process-root :is(.disabled\\:text-\\[\\#6E6E6E\\]:disabled) {
  --tw-text-opacity: 1;
  color: rgb(110 110 110 / var(--tw-text-opacity));
}

#innovation-process-root :is(.disabled\\:text-\\[\\#9B9B9B\\]:disabled) {
  --tw-text-opacity: 1;
  color: rgb(155 155 155 / var(--tw-text-opacity));
}

#innovation-process-root :is(.disabled\\:text-\\[\\#D4D4D4\\]:disabled) {
  --tw-text-opacity: 1;
  color: rgb(212 212 212 / var(--tw-text-opacity));
}

#innovation-process-root :is(.group:hover .group-hover\\:block) {
  display: block;
}

#innovation-process-root :is(.\\[\\&_path\\]\\:fill-white path) {
  fill: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB,iEAA0B;AAA1B;;;CAA0B;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,0BAA0B,EAA1B,MAA0B;AAAA;AAA1B;;EAAA,gBAA0B;AAAA;AAA1B;;;;;;;;CAA0B;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,+HAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,mBAA0B;AAAA;AAA1B;;;;;CAA0B;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,cAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;AAA1B;EAAA,eAA0B;AAAA;AAA1B;EAAA,WAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,oBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,aAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,gBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,wBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,YAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,wBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,kBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;AAA1B;EAAA,UAA0B;AAAA;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,gBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,eAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAC1B;EAAA,WAAgC;EAAhC,kBAAgC;EAAhC,iBAAgC;EAAhC,mBAAgC;EAAhC;AAAgC;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAChC;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gKAA+B;EAA/B,wJAA+B;EAA/B,iLAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;;AAH/B;EAAA,kBAUA;EAVA;AAUA;;AAVA;EAAA,kBAUA;EAVA;AAUA;;AAVA;EAAA;AAUA;;AAVA;EAAA,sBAUA;EAVA;AAUA;;AAVA;EAAA,sBAUA;EAVA;AAUA;;AAVA;EAAA,kBAUA;EAVA;AAUA;;AAVA;EAAA,oBAUA;EAVA;AAUA;;AAVA;EAAA,oBAUA;EAVA;AAUA;;AAVA;EAAA,oBAUA;EAVA;AAUA;;AAVA;EAAA;AAUA;;AAVA;EAAA;AAUA","sourcesContent":["/* src/styles.css */\n@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n@import 'swiper/css';\n@import 'swiper/css/navigation';\n@import 'swiper/css/pagination';\n\n@import 'assets/css/typography';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
